import { FC } from 'react';
import styled from 'styled-components';
import { GeneralError } from 'assets/icons';
import { ClassicButton } from 'components';
import { useHistory } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { clearError } from 'features/ErrorScreen/errorSlice';

const ErrorPageContainer = styled.div`
  padding: 1.5rem;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.milkGrey};
  z-index: 11;

  svg {
    margin-left: 10rem;
  }
`;

const ErrorHeading = styled.h1`
  font-size: 2.25rem;
  font-weight: 600;
  margin: 4rem 0 2.5rem 0;
`;

export const ErrorScreen: FC = () => {
  const history = useHistory();
  const { isVisible } = useAppSelector((state) => state.errorSlice);
  const dispatch = useAppDispatch();

  const closeError = () => {
    history.push('/');
    dispatch(clearError());
  };
  return isVisible ? (
    <ErrorPageContainer>
      <GeneralError />
      <ErrorHeading>There was some problem</ErrorHeading>
      <ClassicButton width="10rem" onClick={closeError}>
        Return to dispoGas
      </ClassicButton>
    </ErrorPageContainer>
  ) : (
    <></>
  );
};
